import { ArtModalModal } from "@components/art_carousel/art_modal_modal";
import { useModalState } from "@hooks/use_modal_state";
import * as types from "@root/types";
import React, { FC } from "react";

interface ArtModalProps {
  artPieces: types.ArtPiece[];
}

const ArtModal: FC<ArtModalProps> = ({ artPieces }) => {
  const { open, close, isOpen } = useModalState();
  return (
    <div>
      <button onClick={open}>Open</button>
      <ArtModalModal
        isOpen={isOpen}
        initialIdx={0}
        close={close}
        artPieces={artPieces}
      />
    </div>
  );
};

export { ArtModal, ArtModalProps };
